<sm-table class="height100p" [data]="table" [allowRemoveRow]=false (onRowSelect)="rowSelect($event)"></sm-table>